import React, { useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ProfileContext } from '../../contexts/ProfileContext';
import { formatMoney } from '../../utilities/parsers';
import Divider from '../Divider';
import AdminGeneralTable from './AdminGeneralTable';
import OrderTableSalidas from '../tables/OrderTableSalidas';
import AdminMissingUsersTable from '../tables/AdminMissingUsersTable';

const BACKEND_HOST = process.env.REACT_APP_API_HOST;

const GeneralTab = ({
  orderNumber,
  order,
  onClickOrderAttachment,
  orderDjango,
  agency,
  materialsStatus,
  results,
  djangoRows,
  nonExistingUsers,
  handleUpdateFile,
  handleDeleteFile,
  downloadFile,
  processOrderComplete,
  orderId,
}) => {
  const { profile } = useContext(ProfileContext);
  const ref = useRef();

  const getDomicilio = () => {
    const { calle, colonia, ciudad } = order;
    let domicilio = '';
    if (calle) domicilio = domicilio.concat(calle);
    if (calle && (colonia || ciudad)) domicilio = domicilio.concat(', ');
    if (colonia) domicilio = domicilio.concat(colonia);
    if (colonia && ciudad) domicilio = domicilio.concat(', ');
    if (ciudad) domicilio = domicilio.concat(ciudad);
    return domicilio;
  };

  const ReportLink = () => {
    if (profile.user) {
      return (
        <button
          className="button is-primary is-medium has-text-weight-semibold"
          onClick={() =>
            window.open(
              `${BACKEND_HOST}reports/order_media_report/${orderDjango.order_number}/${profile.user.id}/`,
              '_blank'
            )
          }
        >
          <span className="icon mr-2">
            <i className="fas fa-file-pdf"></i>
          </span>
          <span>Generar PDF</span>
        </button>
      );
    } else {
      return null;
    }
  };

  return (
    <div>
      {/* Header con Botón de PDF */}
      <div className="box has-background-white-ter" style={{ marginTop: 0 }}>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div>
                <h2 className="title is-5 mb-1">
                  <span className="icon mr-2 has-text-primary">
                    <i className="fas fa-info-circle"></i>
                  </span>
                  Información General
                </h2>
                <p className="subtitle is-6 has-text-grey mb-0">
                  Detalles de la orden y configuración
                </p>
              </div>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">{ReportLink()}</div>
          </div>
        </div>
      </div>

      <div ref={ref} id="generalTab">
        {/* Información Básica de la Orden */}
        <div className="card mb-4">
          <header className="card-header">
            <p className="card-header-title">
              <span className="icon mr-2">
                <i className="fas fa-clipboard-list"></i>
              </span>
              Datos de la Orden
            </p>
          </header>
          <div className="card-content">
            <div className="columns is-multiline">
              {/* Número de Orden */}
              <div className="column is-half-tablet is-one-third-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-hashtag"></i>
                      </span>
                      <span>Número de Orden</span>
                    </span>
                  </label>
                  <div className="field is-grouped">
                    <div className="control is-expanded">
                      <input
                        className="input has-text-centered has-text-weight-semibold"
                        type="text"
                        disabled={true}
                        value={orderNumber[0]}
                      />
                    </div>
                    <div className="control">
                      <span className="button is-static">-</span>
                    </div>
                    <div className="control is-expanded">
                      <input
                        className="input has-text-centered has-text-weight-semibold"
                        type="text"
                        disabled={true}
                        value={orderNumber[1]}
                      />
                    </div>
                    <div className="control">
                      <span className="button is-static">-</span>
                    </div>
                    <div className="control is-expanded">
                      <input
                        className="input has-text-centered has-text-weight-semibold"
                        type="text"
                        disabled={true}
                        value={orderNumber[2]}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Fecha de Alta */}
              <div className="column is-half-tablet is-one-third-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-calendar-plus"></i>
                      </span>
                      <span>Fecha de Alta</span>
                    </span>
                  </label>
                  <div className="control">
                    <input
                      className="input has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={orderDjango.order_date}
                    />
                  </div>
                </div>
              </div>

              {/* Agencia */}
              <div className="column is-half-tablet is-one-third-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-building"></i>
                      </span>
                      <span>Agencia</span>
                    </span>
                  </label>
                  <div className="control">
                    <input
                      className="input has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={agency}
                    />
                  </div>
                </div>
              </div>

              {/* Vigencia de Orden */}
              <div className="column is-full-tablet is-two-thirds-desktop">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-calendar-check"></i>
                      </span>
                      <span>Vigencia de la Orden</span>
                    </span>
                  </label>
                  <div className="field is-grouped">
                    <div className="control is-expanded">
                      <input
                        className="input has-text-weight-semibold"
                        readOnly
                        disabled
                        type="text"
                        placeholder="Fecha desde"
                        value={orderDjango.valid_from}
                      />
                    </div>
                    <div className="control">
                      <span className="button is-static is-primary is-light">
                        <span className="icon">
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </span>
                    </div>
                    <div className="control is-expanded">
                      <input
                        className="input has-text-weight-semibold"
                        readOnly
                        disabled
                        type="text"
                        placeholder="Fecha hasta"
                        value={orderDjango.valid_until}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Anunciante */}
              <div className="column is-full">
                <div className="field">
                  <label className="label has-text-weight-semibold">
                    <span className="icon-text">
                      <span className="icon is-small mr-2">
                        <i className="fas fa-bullhorn"></i>
                      </span>
                      <span>Anunciante</span>
                    </span>
                  </label>
                  <div className="control">
                    <input
                      className="input has-text-weight-semibold"
                      readOnly
                      disabled
                      type="text"
                      value={order['Anunciante'] || 'Sin anunciante'}
                    />
                  </div>
                </div>
              </div>

              {/* Procesar Orden Completa - Solo para No Admin */}
              {!profile.is_admin && (
                <div className="column is-full">
                  <div className="box has-background-success-light" style={{ margin: 0 }}>
                    <div className="level">
                      <div className="level-left">
                        <div className="level-item">
                          <div>
                            <p className="title is-5 mb-1">
                              <span className="icon mr-2 has-text-success">
                                <i className="fas fa-download"></i>
                              </span>
                              Procesar Orden Completa
                            </p>
                            <p className="subtitle is-7 has-text-grey mb-0 is-size-6">
                              Descargar todos los materiales de esta orden
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="level-right">
                        <div className="level-item">
                          <button
                            onClick={() => processOrderComplete()}
                            className="button is-success is-medium has-text-weight-semibold"
                          >
                            <span className="icon mr-2">
                              <i className="fas fa-play"></i>
                            </span>
                            <span>Procesar</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Sección de Salidas */}
        <div className="card mb-4">
          <header className="card-header">
            <p className="card-header-title">
              <span className="icon mr-2">
                <i className="fas fa-list-alt"></i>
              </span>
              Salidas
            </p>
          </header>
          <div className="card-content">
            <div className="table-container">
              {profile.is_admin ? (
                <div>
                  <AdminGeneralTable
                    materials={materialsStatus}
                    handleUpdateFile={handleUpdateFile}
                    handleDeleteFile={handleDeleteFile}
                    downloadFile={downloadFile}
                    orderId={orderId}
                    orderNumber={orderNumber}
                    djangoRows={djangoRows}
                  />
                  {nonExistingUsers && nonExistingUsers.length > 0 && (
                    <div className="mt-4">
                      <AdminMissingUsersTable missingUsers={nonExistingUsers} />
                    </div>
                  )}
                </div>
              ) : (
                <OrderTableSalidas
                  djangoRows={djangoRows}
                  results={results}
                  onClickOrderAttachment={onClickOrderAttachment}
                />
              )}
            </div>
          </div>
        </div>

        {/* Observaciones y Datos Financieros - Solo para No Admin */}
        {!profile.is_admin && (
          <div className="columns">
            <div className="column is-half">
              <div className="card">
                <header className="card-header">
                  <p className="card-header-title">
                    <span className="icon mr-2">
                      <i className="fas fa-comment-alt"></i>
                    </span>
                    Observaciones
                  </p>
                </header>
                <div className="card-content">
                  <div className="field">
                    <div className="control">
                      <textarea
                        disabled
                        className="textarea"
                        placeholder="Sin observaciones adicionales"
                        rows="4"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {( profile.can_see_finance_data || orderDjango.ver_inver_portal) && (
          <div className="column is-half">
            <div className="card">
              <header className="card-header">
                <p className="card-header-title">
                  <span className="icon mr-2">
                    <i className="fas fa-calculator"></i>
                  </span>
                  Resumen Financiero
                </p>
              </header>
              <div className="card-content">
                <div className="table-container">
                  <table className="table is-bordered is-striped is-hoverable is-fullwidth">
                    <tbody>
                      <tr>
                        <th className="has-background-light">
                          <span className="icon-text">
                            <span className="icon is-small mr-2">
                              <i className="fas fa-minus"></i>
                            </span>
                            <span>Subtotal:</span>
                          </span>
                        </th>
                        <td className="has-text-weight-semibold has-text-right">
                          {formatMoney(djangoRows.subtotal)}
                        </td>
                      </tr>
                      <tr>
                        <th className="has-background-light">
                          <span className="icon-text">
                            <span className="icon is-small mr-2">
                              <i className="fas fa-percentage"></i>
                            </span>
                            <span>IVA:</span>
                          </span>
                        </th>
                        <td className="has-text-weight-semibold has-text-right">
                          {formatMoney(djangoRows.iva)}
                        </td>
                      </tr>
                      <tr className="has-background-primary-light">
                        <th className="has-text-primary">
                          <span className="icon-text">
                            <span className="icon is-small mr-2">
                              <i className="fas fa-equals"></i>
                            </span>
                            <span>Total:</span>
                          </span>
                        </th>
                        <td className="has-text-weight-bold has-text-right has-text-primary">
                          {formatMoney(djangoRows.total)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralTab;
